import React, { useLayoutEffect } from 'react'
import { navigate } from 'gatsby'
import { useTranslations } from '../hooks/use-translations'

const TryPage: React.FC = () => {
  const { getPath } = useTranslations()
  useLayoutEffect(() => {
    navigate(getPath('/'), {
      state: { tryModalOpened: true },
    })
  }, [getPath])
  return null
}

export default TryPage
